/* eslint-disable */
export interface FormRole {
  FormId: string;
  RoleId: string;
  RoleName: string;
  FormActionId?: number;
  FormActionName: string;
  bActive: boolean;
}
